var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod"},[_c('div',{staticClass:"box-other"},[_c('img-swiper-block')],1),_c('div',{staticClass:"box"},[_c('floor-class-book'),_c('floor-class-course')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }